import { createRouter, createWebHistory } from 'vue-router'
import GetRewardsHome from '../views/GetRewardsHome.vue'

// Download Rewards Card
import DownloadAfterSignIn from '../views/DownloadRewardsCard/DownloadAfterSignIn.vue'
import DownloadAfterRegister from '../views/DownloadRewardsCard/DownloadAfterRegister.vue'

// Account Only (A3 Process Flow)
import SignInToRewards from '../views/Login/SignInToRewards.vue'
import JoinRewardsHome from '../views/FailedLogin/JoinRewardsHome.vue'

import VerifyAccount from '../views/FailedLogin/VerifyAccount.vue'
import RetrieveRewards from '../views/RetrieveRewardsCard/RetrieveRewards.vue'
import RetrieveRewardsConfirm from '../views/RetrieveRewardsCard/RetrieveRewardsConfirm.vue'

// Rewards Only (A1 & A2 Process Flow)
import CreatingAccount from '../views/Register/CreatingAccount.vue'

// Rewards Only (A1 Process Flow)
import GetRewardsRegister from '../views/Register/GetRewardsRegister.vue'
import JoinRewardsRegister from '../views/Register/JoinRewardsRegister.vue'

// 2FA
import SelectVerificationMethod from '../views/OTP/SelectVerificationMethod.vue'
import VerifyOTP from '../views/OTP/VerifyOTP.vue'

//MyBeauty
import JoinMyBeauty from '../views/Register/JoinMyBeauty.vue'

// OIDC Callback
import Callback from '../views/Login/Callback.vue'
import VerificationCallback from '../views/Login/VerificationCallback.vue'
import Proxy from '../views/Login/Proxy.vue'
import LoginScreenset from '../views/Login/LoginScreenset.vue'
import ConfirmPasswordReset from '../views/PasswordReset/ConfirmPasswordResetScreenset.vue'

const routes = [
    {
        path: '/',
        redirect: '/en-gb',
        props: true
    },
    {
        path: '/:isMyBeauty(mybeauty)?/callback',
        name: 'Callback',
        component: Callback,
        props: true
    },
    {
        path: '/en-gb/proxy',
        name: 'Proxy',
        component: Proxy,
        props: true
    },
    {
        path: '/confirm-reset',
        name: 'ConfirmPasswordReset',
        component: ConfirmPasswordReset,
        props: true
    },
    {
        path: '/en-gb/login',
        name: 'Login',
        component: LoginScreenset,
        props: true
    },
    {
        path: '/verified',
        name: 'VerificationCallback',
        component: VerificationCallback
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?',
        name: 'GetRewardsHome',
        component: GetRewardsHome,
        props: true
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/creating-account',
        name: 'CreatingAccount',
        component: CreatingAccount,
        props: route => ({ newUser: route.params.newUser })
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/download',
        name: 'DownloadAfterSignIn',
        component: DownloadAfterSignIn,
        props: true
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/register/download',
        name: 'DownloadAfterRegister',
        component: DownloadAfterRegister,
        props: true
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/sign-in',
        name: 'SignInToRewards',
        component: SignInToRewards,
        props: true
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/register',
        name: 'GetRewardsRegister',
        component: GetRewardsRegister,
        props: true
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/register',
        name: 'JoinRewardsRegister',
        component: JoinRewardsRegister,
        props: true
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/events-register',
        name: 'EventsJoinRewardsRegister',
        component: JoinRewardsRegister,
        props: true
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/join',
        name: 'JoinRewardsHome',
        component: JoinRewardsHome,
        props: true
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/join-mybeauty',
        name: 'JoinMyBeauty',
        component: JoinMyBeauty,
        props: true
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/retrieve-card-number',
        name: 'RetrieveRewards',
        component: RetrieveRewards,
        props: true
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/retrieve-card-number/confirm',
        name: 'RetrieveRewardsConfirm',
        component: RetrieveRewardsConfirm,
        props: true
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/verify',
        name: 'VerifyAccount',
        component: VerifyAccount,
        props: true
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/send-verification-code',
        name: 'SelectVerificationMethod',
        component: SelectVerificationMethod,
        props: true
    },
    {
        path: '/en-gb/:isMyBeauty(mybeauty)?/verify-otp',
        name: 'VerifyOTP',
        component: VerifyOTP,
        props: true
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior() {
        return { left: 0, top: 0 }
    },
    routes
})

router.beforeEach((to, from, next) => {
    if (from.params.isMyBeauty && !to.params.isMyBeauty) {
        next({ name: to.name, params: { ...to.params, isMyBeauty: "mybeauty" }, replace: true })
    } else {
        next()
    }
})

export default router
